import { Button } from "@/components/ui/je-button"
import { useEffect, useState } from "react"
import { useLanguage } from "@/contexts/LanguageContext"

const HeroSection = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0)
  const { t } = useLanguage()
  
  const rotatingWords = [
    t('hero.words.software'),
    t('hero.words.ai'), 
    t('hero.words.robotics'),
    t('hero.words.agriculture'),
    t('hero.words.architecture'),
    t('hero.words.mechanical')
  ]

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    
    if (!prefersReducedMotion) {
      const interval = setInterval(() => {
        setCurrentWordIndex((prev) => (prev + 1) % rotatingWords.length)
      }, 2000) // 2s par mot pour transition plus naturelle
      
      return () => clearInterval(interval)
    }
  }, [rotatingWords.length])

  return (
    <section className="min-h-screen flex items-center justify-center hero-modern pt-16 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="mb-8 sm:mb-12">
          <h1 className="text-hero text-je-black leading-tight mb-6 sm:mb-8 break-words">
            {t('hero.title')}
          </h1>
          
          {/* Rotating words display - slightly larger than main text */}
          <div className="text-[calc(3.5rem*1.1)] md:text-[calc(4.5rem*1.15)] lg:text-[calc(5.5rem*1.15)] font-black text-gradient mb-8 leading-tight min-h-[4rem] md:min-h-[5rem] lg:min-h-[6rem] flex items-center justify-center">
            <span 
              key={currentWordIndex} 
              className="inline-block animate-fade-in"
              style={{ animationDuration: '0.6s' }}
            >
              {rotatingWords[currentWordIndex]}
            </span>
          </div>
          
          <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-4xl mx-auto leading-relaxed font-medium px-2">
            {t('hero.subtitle')} 
            <br className="hidden sm:block" />
            {t('hero.subtitle2')}
          </p>
        </div>

        <div className="flex flex-col gap-4 sm:gap-6 justify-center items-center mb-16 sm:mb-20 px-4">
          <Button size="xl" className="w-full sm:w-auto sm:min-w-[220px] btn-modern animate-pulse-glow" asChild>
            <a href="#contact">{t('nav.launchProject')}</a>
          </Button>
          <Button 
            variant="outline" 
            size="xl" 
            className="w-full sm:w-auto sm:min-w-[220px] btn-modern"
            asChild
          >
            <a href="/rejoindre">{t('nav.joinTeam')}</a>
          </Button>
        </div>

      </div>
      
      {/* Abstract Tech Illustration */}
      <div className="absolute inset-0 z-0 opacity-5">
        <svg
          className="w-full h-full"
          viewBox="0 0 800 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="techGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="hsl(var(--je-red))" />
              <stop offset="50%" stopColor="hsl(var(--eth-purple))" />
              <stop offset="100%" stopColor="hsl(var(--eth-green))" />
            </linearGradient>
          </defs>
          <g fill="url(#techGradient)">
            <circle cx="150" cy="100" r="40" opacity="0.3" />
            <rect x="600" y="80" width="60" height="60" rx="8" opacity="0.4" />
            <polygon points="400,50 450,100 400,150 350,100" opacity="0.3" />
            <circle cx="700" cy="400" r="50" opacity="0.2" />
            <rect x="100" y="450" width="80" height="80" rx="12" opacity="0.3" />
            <polygon points="500,500 580,520 560,580 480,560" opacity="0.4" />
          </g>
        </svg>
      </div>
    </section>
  )
}

export default HeroSection